/**
 * Wait for all media (images and videos) in an element to be ready
 * @param {jQuery} element 
 * @param {number} timeout - Maximum time to wait in ms
 * @returns {Promise}
 */
export function mediaReady(element, timeout = 5000) {
    const images = element.find('img');
    const videos = element.find('video');

    if (images.length === 0 && videos.length === 0) {
        return Promise.resolve();
    }


    const promises = [];

    // Images
    images.each(function () {
        if (this.complete) return;

        promises.push(new Promise(resolve => {
            $(this).one('load error', resolve);
        }));
    });

    // Videos
    videos.each(function (vIndex) {
        const video = this;
        const videoSrc = $(video).find('source').attr('src') || video.src;

        // If the video is already ready to play at least the current frame
        if (video.readyState >= 2) {
            return;
        }


        // If it's a lazy-load video, trigger it if the library is available
        if ($(video).hasClass('lazy-load') && typeof $.fn.Lazy === 'function') {
            $(video).Lazy();
        }

        promises.push(new Promise(resolve => {
            const onReady = (e) => {
                resolve();
            };

            // Wait for enough data to show the first frame or play through
            $(video).one('loadeddata canplay canplaythrough error', onReady);

            // Ensure video is loading if it's not already
            if (video.load && video.readyState === 0) {
                try {
                    video.load();
                } catch (e) {
                    console.warn("mediaReady: video.load() failed", e);
                }
            }
        }));
    });

    // Return promise with timeout safety
    return new Promise(resolve => {
        let isResolved = false;

        const timeoutId = setTimeout(() => {
            if (!isResolved) {
                isResolved = true;
                console.warn('mediaReady: Timed out waiting for media');
                resolve();
            }
        }, timeout);

        Promise.all(promises).then(() => {
            if (!isResolved) {
                isResolved = true;
                clearTimeout(timeoutId);
                resolve();
            }
        }).catch(err => {
            console.error('mediaReady: Error in media promises', err);
            if (!isResolved) {
                isResolved = true;
                clearTimeout(timeoutId);
                resolve();
            }
        });
    });
}
